// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"227":"1c268b02","614":"f47ddb14","698":"5bc33efd","838":"195149b5"}[chunkId] + ".css";
};